import { Button, Form, Select, message, notification } from "antd";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import axios from "../../../config/axiosInstance";
import { API } from "../../../config/API";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LoadTags } from "../../../utils/commonapis";
import ImageItem from "../../../component/imageItem";
import ImagePicker from "../../../component/imagePicker";
import { IoArrowBackCircleOutline } from "react-icons/io5";

import "../styles.css";

function NjayarMasterForm() {
  const navigate = useNavigate();
  const User = useSelector((state: any) => state.User.user);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [tagFilter, setTagFilters] = useState("");
  const [tagLoading, setTagLoading] = useState(true);

  const [form] = Form.useForm();
  const [imageuploaddata, setImageuploaddata] = useState<any>({
    imageurl1: "",
  });
  const [uploadImg, setUploadImg] = useState(false);
  const [imageType, setImageType] = useState("");
  const [imageName, setImageName] = useState("");

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  const loadTags = async (searchTerm: any) => {
    setTagLoading(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setTagLoading(false);
    }
  };

  function deleteImagesFromList(key: any) {
    try {
      setImageuploaddata((prevImages: any) => {
        const updatedImages = { ...prevImages };
        updatedImages[key] = "";
        return updatedImages;
      });
      notification.success({ message: `Image Removed` });
    } catch (err) {
      notification.error({ message: `Failed to remove` });
    }
  }

  const addImagesToList = (data: any) => {
    try {
      let DataObj = { ...imageuploaddata };
      if (data.type === "image1") {
        DataObj["imageurl1"] = data.image_url;
      }
      setImageuploaddata(DataObj);
      setUploadImg(false);
      notification.success({ message: `Image uploaded successfully` });
    } catch (err) {
      notification.error({ message: `Failed to upload image` });
    }
  };

  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const onFinish = async (values: any) => {
    setLoading(true);
    let requestObj = {
      data: {
        head: values?.title,
        permalink: values?.permalink,
        tags: values.tags,
        user: User?.id,
        thumbnail: imageuploaddata.imageurl1,
      },
    };
    let url = API.BASE_URL + API.NJAYAR_MASTER;
    axios
      .post(url, requestObj)
      .then((response) => {
        setLoading(false);
        message.success("Njayar Master created successfully");
        navigate(
          `/Auth/unified-content/njayar/master/${response?.data?.data?.id}`,
          { state: { items: response?.data?.data } }
        );
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.error("Failed to create");
      });
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <div className="uc-form-page">
      {/* Top Bar */}
      <div className="uc-topbar">
        <div className="uc-topbar-row">
          <div
            className="uc-topbar-back"
            onClick={() => navigate("/Auth/unified-content?tab=njayar")}
          >
            <IoArrowBackCircleOutline />
          </div>
          <div>
            <div className="uc-topbar-title">Create Njayar Prabhaatham</div>
          </div>
          <div className="uc-topbar-spacer" />
        </div>
      </div>

      {/* Form */}
      <div className="uc-form-body" style={{ maxWidth: 800, margin: "0 auto", padding: "24px 16px" }}>
        <div className="uc-card">
          <Form onFinish={onFinish} form={form} name="njayar-master-form">
            <Row>
              <Col sm={12} xs={12}>
                <label className="uc-label">Title *</label>
                <Form.Item
                  name="title"
                  {...formItemLayout}
                  rules={[{ required: true, message: "Title is required" }]}
                >
                  <TextArea rows={2} placeholder="Enter title" />
                </Form.Item>
              </Col>

              <Col sm={12} xs={12}>
                <label className="uc-label">Tags</label>
                <Form.Item name="tags" {...formItemLayout}>
                  <Select
                    mode="multiple"
                    placeholder="Select tags"
                    filterOption={(input: any, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input.toLowerCase()) >= 0
                    }
                    loading={tagLoading}
                    onSearch={(val) => OnTagSearch(val)}
                  >
                    {tags.length > 0 &&
                      tags.map((item: any) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.tag}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col sm={12} xs={12}>
                <label className="uc-label">Permalink</label>
                <Form.Item name="permalink" {...formItemLayout}>
                  <TextArea rows={1} placeholder="Enter permalink" />
                </Form.Item>
              </Col>

              <Col sm={6} xs={12}>
                <label className="uc-label">Thumbnail</label>
                <ImageItem
                  imageurl={imageuploaddata?.imageurl1}
                  upload={() => {
                    if (imageuploaddata?.imageurl1 === "") {
                      setImageType("image1");
                      setImageName("Thumbnail");
                      setUploadImg(true);
                    }
                  }}
                  delete={() => deleteImagesFromList("imageurl1")}
                />
              </Col>

              <Col sm={12} xs={12} style={{ marginTop: 24 }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    htmlType="submit"
                    loading={loading}
                    type="primary"
                    size="large"
                  >
                    Create & Add Articles
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      <ImagePicker
        mode="create"
        imageType={imageType}
        imageName={imageName}
        onSubmit={(val: any) => addImagesToList(val)}
        visible={uploadImg}
        close={() => setUploadImg(false)}
      />
    </div>
  );
}

export default NjayarMasterForm;
